module.exports = __webpack_public_path__ + "static/media/movily2-form.68034b70.PNG";